import { currencies } from '@/functions';

export const getStatus = ({ content, status }) => {
  if (!content) {
    if (status === 'WAITING_FOR_PAYMENT') return 'Menunggu Pembayaran';
    if (status === 'WAITING_FOR_UPDATE') return 'Menunggu Update';
    if (status === 'PAID') return 'Dalam Proses';
    if (status === 'ACTIVE') return 'Aktif';
    if (status === 'REJECTED') return 'Ditolak';
    if (status === 'CANCELLED') return 'Dibatalkan';
    if (status === 'EXPIRED') return 'Tidak Berlaku Lagi';
  } else {
    return content[status];
  }
  return status;
};

export const getHolderInformation = ({ content, data }) => {
  const info = [
    { label: content.nameLabel, value: data.fullName },
    { label: content.emailLabel, value: data.email },
    { label: content.phoneNumberLabel, value: data.phoneNumber }
  ];
  return info;
};

export const getVehicleDetailInformation = ({ content, data, type }) => {
  const info = [
    {
      label: content.QoalaOnlineCarPayment.platNumberLabel,
      value: data.plate + ' ' + (data.plateNumber || '')
    },
    {
      label:
        type === 'CAR' ? content.QoalaOnlineCarPayment.carBrandLabel : content.QoalaOnlineMotorPayment.motorBrandLabel,
      value: data.manufacturer
    },
    {
      label:
        type === 'CAR' ? content.QoalaOnlineCarPayment.carTypeLabel : content.QoalaOnlineMotorPayment.motorTypeLabel,
      value: data.brand
    },
    {
      label:
        type === 'CAR'
          ? content.QoalaOnlineCarPayment.carSeriesLabel
          : content.QoalaOnlineMotorPayment.motorSeriesLabel,
      value: data.series
    }
  ];
  return info;
};

export const getProductInformation = ({ content, data }) => {
  const productInformation = [
    {
      label: content.insuranceNameLabel,
      value: data.name
    },
    {
      label: content.activePeriodLabel,
      value: data.startedDate + ' - ' + data.expiredDate
    },
    {
      label: data.type === 'CAR' || data.type === 'MOTOR' ? content.totalSumLabel : '',
      value: data.type === 'CAR' || data.type === 'MOTOR' ? data.totalPrice : ''
    }
  ];
  if (data.addons && data.addons.lis) {
    data.addons.list.map(item => {
      const data = {
        label: item.name,
        value: `${item.currency} ${currencies(item.price)}`
      };
      productInformation.push(data);
    });
  }
  return productInformation;
};
